<template>
  <div class="bread-crumb">
    <v-breadcrumbs :items="bcrumbs">
      <v-icon slot="divider">chevron_right</v-icon>
      <template slot="item" slot-scope="props">
        <router-link :to="props.item.href" :class="[props.item.disabled && 'disabled', 'crumb']">{{ props.item.text }}</router-link>
      </template>
    </v-breadcrumbs>
     <div class="nome-tela"  aria-live="assertive" >{{nomeTela}}</div>
      <p style="opacity:0; font-size:0px; margin:0px; padding:0px;" id="nome-tela-auxiliar" aria-live="assertive"  ></p>
    </div>
</template>

<script>
export default {
  name: 'BreadCrumb',
  data() {
    return {
      nomeTela: '',
    };
  },
  created() {
   document.addEventListener('keydown', this.onKeyDown);
  },
  computed: {
    bcrumbs() {
      let pathArray = this.$route.path.split('/');
      if(pathArray.length > 1 && pathArray[1] === '') { pathArray.shift(); }

      const breadCrumbs = pathArray.reduce((total, value, index) => {
        // if(pathArray.length-1 === index && (value === '' || !isNaN(value))) { return total; }

        const href = `${(total[index-1])? `${total[index-1].href}` : ''}${(total[index-1] && total[index-1].href === '/')? '' : '/'}${value}`;
        const { route } = this.$router.resolve({
          path: href,
        });

        if(pathArray.length-1 === index && (value === '' || !isNaN(value))) { 
          this.nomeTela = route.meta.breadCrumb || value;
          return total; 
        }

        total.push({
          href,
          text: ((!isNaN(value) && index !== 0)? value : route.meta.breadCrumb || value),
          disabled: route.meta.breadCrumbDisabled || false,
        });

        if(pathArray.length-1 === index) {
          total[index].disabled = true;
          this.nomeTela = total[index].text;
        }

        return total;
      }, []);

      return breadCrumbs;
    }
  },
    methods: {
    onKeyDown(event)  {
      if (event.altKey && event.key === 't') {
        let elementoParaLeitura = document.getElementById('nome-tela-auxiliar');

        if (elementoParaLeitura.textContent != '') {
          elementoParaLeitura.textContent = '';
          setTimeout(() => {onKeyDown(event)},2500);
          } else {
            let conteudoLeitura =  "Você está na tela: " + document.getElementsByClassName('nome-tela')[0].textContent;
                elementoParaLeitura.textContent = conteudoLeitura;
                setTimeout(() => {elementoParaLeitura.textContent = ''},250)
          };
      };
    }   
  },  
}
</script>

<style lang="scss">
.bread-crumb {
  // padding: 15px;
  .v-breadcrumbs {
    padding: 3px 15px;
  }

  .crumb {
    text-decoration: none;
    color: #015d89;
    
    &:hover {
      color: #039be5;
    }
  }

  .disabled {
  color: grey;
  pointer-events: none;
  }

  .nome-tela {
    font-size: 24px;
    margin-left: 15px;
  }
}
</style>
